<template>
  <div>
    <my-notification :icon="'warning'">
      <template #title>
        {{ $t('compCarbonDocsNotes.title-notes') }}
      </template>
      <p>
        {{ $t('compCarbonDocsNotes.notes-1-1') }}<br />
        {{ $t('compCarbonDocsNotes.notes-1-2')
        }}<b>{{ $t('compCarbonDocsNotes.notes-1-b') }}</b
        >{{ $t('compCarbonDocsNotes.notes-1-3') }}<br />
        {{ $t('compCarbonDocsNotes.notes-1-4') }}
        <a
          class="link"
          href="/static/carbon/Pourquoi_faire_Bges_labo_Blanchard_15122020.pdf"
          target="_blank"
          >{{ $t('compCarbonDocsNotes.notes-1-a') }}</a
        >.
      </p>
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Notes',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  props: ['header']
}
</script>
